<template>
  <div class="onboarding-signup-step-family">
    <transition appear :enter-active-class="transition.classes.enter" :leave-active-class="transition.classes.leave">
      <QPage padding>
        <h2 class="step-title">
          {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.SIGNUP.STEPS.MAIN.FAMILY.@TITLE")) }}
        </h2>

        <Family :families="families" :selected-family-id="selectedFamilyId" @on-select="selectFamily" />
      </QPage>
    </transition>
  </div>
</template>

<script setup>
  import { NotificationsManager } from "@core/managers/notifications.manager";
  import { useSignup } from "@etab/composables";
  import { ACTION_SIGNUP_UPDATE, ACTION_FAMILY_INIT, GETTER_FAMILY, GETTER_SIGNUP_GET } from "@etab/stores/types";
  import { useSignupStore } from "@etab/stores/signup";
  import { useEtabFamilyStore } from "@etab/stores/etab-family";
  import { ISignup } from "@core/models";
  import { TrackingManager } from "@core/managers/tracking.manager";
  import { FIREBASE_EVENTS } from "@core/constants";
  import { computed, onMounted } from "vue";
  import { LoadingManager } from "@core/managers/loading.manager";
  import { useTransition } from "@core/composables";

  import Family from "@etab/components/onboarding/signup/Family.component.vue";

  const { transition } = useTransition();
  const { $_nextStep } = useSignup();
  const signupStore = useSignupStore();
  const etabFamilyStore = useEtabFamilyStore();

  const families = computed(() => {
    return etabFamilyStore[GETTER_FAMILY];
  });

  const selectedFamilyId = computed(() => {
    return signupStore[GETTER_SIGNUP_GET][ISignup.familyId];
  });

  const initFamilies = async function () {
    try {
      LoadingManager.show();
      await etabFamilyStore[ACTION_FAMILY_INIT]();
    } catch (error) {
      NotificationsManager.error({ message: "ERRORS.@NETWORK_ISSUE" });
      throw error;
    } finally {
      LoadingManager.hide();
    }
  };

  const selectFamily = function (family) {
    const data = {
      [ISignup.familyId]: family.getId(),
      [ISignup.categoryId]: undefined, // reset category
      [ISignup.segment]: undefined, // reset segment
      [ISignup.isLarge]: undefined, // reset size
      [ISignup.isGroup]: undefined, // reset group
    };
    TrackingManager.addEvent({
      event: FIREBASE_EVENTS.FUNNEL,
      step: "step6_family",
    });
    signupStore[ACTION_SIGNUP_UPDATE](data);
    $_nextStep();
  };

  onMounted(() => {
    if (etabFamilyStore[GETTER_FAMILY].length === 0) {
      initFamilies();
    }
  });
</script>
